import { BalanceSheetModel } from "@/models/balanceSheet.model";
import { Equipment,RotationType } from "@/models/equipment.model";
import { Settings } from "@/models/settings.model";
import { ElementaryZone, SiteModel } from "@/models/site.model";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
import ElementaryZoneDisplay from "./parts/ElementaryZoneDisplay/index.vue";
import { abacaEvent, getEventJsonData, StatisticPayload } from "@/services/statistics.service";
import { SEND_JSON_STATISTICS } from "@/store/operators";
import { GlobalSettings } from "@/models/global.model";
import { generatePDFReport } from "@/services/pdfReport";
import DownloadReportSpinner from "./parts/DownloadReportSpinner/index.vue";
import DownloadReportError from "./parts/DownloadReportError/index.vue";
import { AxiosResponse } from "axios";
import { ExcelPayload } from "@/models/excelPayload.model";
import { exportToExcel } from "@/services/export.service";
import { calculateWindSpeed} from "@/services/balanceSheet.service";
import moment from "moment";

@Component({
  components: {
    ElementaryZoneDisplay,
    DownloadReportSpinner,
    DownloadReportError,
  },
})
export default class BalanceSheetComponent extends Vue {
  mounted(): void {
    //
    // send json statistics on receive balance sheet results
    this.sendBalanceSheetResultsJsonStatistics();
  }

  /*
  Export app data to an excel
  */
  exportToExcel(): void {
    const balanceSheetJson = this.buildJsonExcel();
    // build filename
    const fileName = this.$i18n
      .t("configurations.export_excel", {
        date: moment().format("YYYY-MM-DD"),
        time: moment().format("HH[h]mm"),
      })
      .toString();

    exportToExcel(balanceSheetJson).then((response: AxiosResponse) => {

      // export excel not using file save because encoding type is ANSI and not UTF-8
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}.xlsx`); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  }

  // get global name of application
  get globalAbacaDataName(): string {
    return store.state.globalAppDataModule.dataName;
  }

  get globalAbacaDataType(): string {
    return store.state.globalAppDataModule.dataType;
  }

  get globalAbacaDataTypeVersion(): string {
    return store.state.globalAppDataModule.dataTypeVersion;
  }
  get isExistListOptinalEacm() :boolean {
    const listSitesOptional = store.state.equipmentsModule.optionalEacmsites;

    if(listSitesOptional && listSitesOptional.length>0) return true;
    else return false
  }

  /*
  Return excel payload from app data
  */
  buildJsonExcel(): ExcelPayload {
    
    const balanceSheet: ExcelPayload = {
      dataType: this.globalAbacaDataType,
      dataName: this.globalAbacaDataType,
      dataTypeVersion: this.globalAbacaDataTypeVersion,
      site: this.site,
      eacmEquipment: this.eacmModel,
      optionalEacmEquipment: this.optionaleacmModel, /*Evolution majeure de EACM */
      earEquipment: this.earModel,
      optionalExtractor: this.optionalExtractor,
      isSecurityExtractorRequired: store.state.equipmentsModule.isSecurityExtractorRequired,
      balanceSheet: {
        ...this.balanceSheet,
        depressionToMaintainRenewalRate: this.balanceSheet.depressionToMaintainRenewalRate.toFixed(1),
        minimalDepressionRenewalRate: this.balanceSheet.minimalDepressionRenewalRate.toFixed(1),
        depressionToMaintainLeakRate: this.balanceSheet.depressionToMaintainLeakRate.toFixed(1),
        minimalDepressionLeakRate: this.balanceSheet.minimalDepressionLeakRate.toFixed(1),


      },
      settings: this.settings,
    };
    return balanceSheet;
  }

  tooltipHelpSiteSection = this.$sanitize(this.$t("help.balanceSheetPage.siteSection").toString());
  tooltipHelpExtractorsSection = this.$sanitize(
    this.$t("help.balanceSheetPage.extractorsSection").toString()
  );
  tooltipHelpAirEntrySection = this.$sanitize(
    this.$t("help.balanceSheetPage.airEntrySection").toString()
  );
  tooltipHelpAirEntryByZone = this.$sanitize(
    this.$t("help.balanceSheetPage.airEntryByZoneSection").toString()
  );

  visible = true;

  get site(): SiteModel {
    return store.state.siteModule.site;
  }

  get balanceSheet(): BalanceSheetModel {
    return store.state.siteModule.balanceSheet;
  }

  get eacmModel(): Equipment {
    return store.state.equipmentsModule.eacmEquipment;
  }
  /*Evolution majeure de EACM */
  get optionaleacmModel(): Equipment {
    return store.state.equipmentsModule.optionalEacmEquipment;
  }
  get optionalExtractor(): Equipment {
    return store.state.equipmentsModule.optionalExtractor;
  }

  get isSecurityExtractorRequired(): Equipment {
    return store.state.equipmentsModule.isSecurityExtractorRequired;
  }

  get earModel(): Equipment {
    return store.state.equipmentsModule.earEquipment;
  }

  get settings(): Settings {
    return store.state.settingsModule.settings;
  }

  get globalSettings(): GlobalSettings {
    return store.state.globalAppDataModule.settings;
  }

  get totalZoneNumber(): number {
    return store.getters.NB_ELEMENTARY_ZONE;
  }

  get rotationType(): string {
    if (this.balanceSheet && this.balanceSheet.bigExtractor.extractor.rotation_type === RotationType.variable) {
      return this.$t("components.equipmentPage.equipmentDisplay.rotationVariable").toString();
    } else {
      return "";
    }
      
  }
  get rotationTypeSmall(): string {
    if ( this.balanceSheet && this.balanceSheet.smallExtractor.extractor.rotation_type === RotationType.variable) {
      return this.$t("components.equipmentPage.equipmentDisplay.rotationVariable").toString();
    } else {
      return "";
    }
  }
  get winSpeedValue(): number {
    const value = calculateWindSpeed(this.settings.depressionValuetoMaintain)
    return  value;
  }

 

  //gathers all zones witch as extractor
  get extractorZones(): string {
    let zoneNames = this.$t(
      "components.balanceSheetPage.extractorsSection.zoneRepartitionLabel"
    ).toString();
    const zones = this.getElementaryZonesHavingExtractors();
    zones.forEach((zone, index) => {
      zoneNames += `${zone.name}`;
      if (index < zones.length - 1) {
        zoneNames += ` ${this.$t(
          "components.balanceSheetPage.extractorsSection.zoneSeparator"
        ).toString()} `;
      }
    });
    return zoneNames;
  }

  // round Value with the number of precision we define
  roundValue(value: string, precision: number): string {
    return (Math.round(parseFloat(value) * 10) / 10).toFixed(precision);
  }

  getElementaryZonesHavingExtractors(): ElementaryZone[] {
    return this.site.elementaryZones.filter((zone) => zone.extractorsInstallation);
  }

  sendBalanceSheetResultsJsonStatistics(): void {
    const eacmEquipments = this.eacmModel;
    const earEquipment = this.earModel;
    const optionalEquipment = this.optionaleacmModel; /*Evolution majeure de EACM */
    const site = this.site;
    const balanceSheet = this.balanceSheet;
    const setting = this.settings;
    const extractorZones = this.extractorZones;
    const totalZoneNumber = this.totalZoneNumber;
    const payload: StatisticPayload = {
      key: "balanceSheet",
      data: {
        eacmEquipments,
        earEquipment,
        optionalEquipment,
        site,
        balanceSheet,
        setting,
        extractorZones,
        totalZoneNumber,
      },
    };
    store.dispatch(SEND_JSON_STATISTICS, getEventJsonData(abacaEvent.BALANCESHEET, payload));
  }

  showSpinner(): void {
    this.$bvModal.show("downloadReportSpinner");
  }

  hideSpinner(): void {
    this.$bvModal.hide("downloadReportSpinner");
  }

  exportPdf(): void {
    this.showSpinner();
    const settings: Settings = store.state.settingsModule.settings;
    const globaleSettings: GlobalSettings = store.state.globalAppDataModule.settings;
    const balanceSheet: BalanceSheetModel = store.state.siteModule.balanceSheet;
    const eacmModel: Equipment = store.state.equipmentsModule.eacmEquipment;
    const optionaleacmModel: Equipment = store.state.equipmentsModule.optionalEacmEquipment; /*Evolution majeure de EACM */
    const earModel: Equipment = store.state.equipmentsModule.earEquipment;
    const isSecurityExtractorRequired: boolean =
      store.state.equipmentsModule.isSecurityExtractorRequired;
    const optionalExtractor: Equipment = store.state.equipmentsModule.optionalExtractor;
    const site: SiteModel = store.state.siteModule.site;
    const fileName = this.$i18n.t("components.options.pdfTitle").toString();
    generatePDFReport(
      settings,
      globaleSettings,
      balanceSheet,
      eacmModel,
      optionaleacmModel, /*Evolution majeure de EACM */
      earModel,
      isSecurityExtractorRequired,
      optionalExtractor,
      site,
      fileName
    )
      .catch((error) => {
        console.error(error);
        this.$bvModal.show("downloadReportError");
      })
      .finally(() => {
        this.hideSpinner();
      });
  }
}
